<script setup lang="ts">
import { computed } from "vue";
import ScaleMenuState from "@/stores/ScaleMenuState";
import type { ScaleConfig } from "@/types/legend.types";
import ScaleRow from "@/components/canvas/DrawerMenus/Settings/ScaleRow.vue";

/** Une échelle de la liste de l'en-tête : la choisir la rend active. */
const props = defineProps<{ scale: ScaleConfig }>();
const emit = defineEmits<{ (e: "select", scale: ScaleConfig): void }>();

const isActive = computed(
  () => ScaleMenuState.activeScale?.name === props.scale.name,
);
</script>

<template>
  <button
    type="button"
    class="scale-list-item"
    :class="{ active: isActive }"
    :aria-pressed="isActive"
    @click="emit('select', scale)"
  >
    <ScaleRow
      :scale="scale"
      :forced-size="ScaleMenuState.forcedSizeOf(scale)"
    />
  </button>
</template>

<style lang="scss" scoped>
.scale-list-item {
  display: block;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-size: 13px;
  text-align: left;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
    color: white;
  }

  &.active {
    color: var(--canvas-btn-active-bg);
    font-weight: 600;
  }
}
</style>
